import React from 'react'

import PropTypes from 'prop-types'

import './testimonal.css'

const Testimonal = (props) => {
  return (
    <div className="testimonal-thq-testimonal-elm testimonal">
      <span className="testimonal-text">{props.quote}</span>
      <div className="testimonal-thq-author-elm">
        <div className="testimonal-thq-avatar-elm">
          <img
            alt={props.avatarAlt}
            src={props.avatarSrc}
            className="testimonal-thq-image-elm"
          />
        </div>
        <div className="testimonal-thq-user-elm">
          <span className="testimonal-thq-name-elm">{props.name}</span>
          <span className="testimonal-thq-divider-elm">—</span>
          <span className="testimonal-thq-from-elm">{props.from}</span>
        </div>
      </div>
    </div>
  )
}

Testimonal.defaultProps = {
  from: 'Vista Social',
  avatarAlt: 'image',
  avatarSrc:
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDV8fGdpcmx8ZW58MHx8fHwxNjY0ODA5MjE1&ixlib=rb-1.2.1&w=200',
  name: 'Andy Smith',
  quote:
    '"Pellentesque sodales libero nulla, ac imperdiet ante tincidunt vel. Fusce auctor augue sed massa finibus, et dictum sem mollis. In luctus.”',
}

Testimonal.propTypes = {
  from: PropTypes.string,
  avatarAlt: PropTypes.string,
  avatarSrc: PropTypes.string,
  name: PropTypes.string,
  quote: PropTypes.string,
}

export default Testimonal
